"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.receivedBloodTransfusionYear = exports.receivedBloodTransfusionReason = exports.receivedBloodTransfusionOption = exports.receivedBloodTransfusionCountry = exports.receivedBloodTransfusionConfig = exports.receivedBloodTransfusion = exports.ReceivedBloodTransfusionDefinition = void 0;

var _countryList = _interopRequireDefault(require("../../../utils/countryList"));

var _range = require("../../../utils/range");

var _component = require("../../../types/component");

var _index = require("../../config/index");

var _fieldDefinitionTypes = require("../../../fields/config/fieldDefinitionTypes");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var RadioDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.RadioDefinition;
});

var SelectDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.SelectDefinition;
});

var TextfieldDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.TextfieldDefinition;
});

var ComponentConfigDefinition = _flowRuntime["default"].tdz(function () {
  return _index.ComponentConfigDefinition;
});

var ComponentElementDefinition = _flowRuntime["default"].tdz(function () {
  return _component.ComponentElementDefinition;
});

var receivedBloodTransfusionOption = {
  key: 'option',
  type: 'radio',
  normalize: 'boolean',
  items: [{
    key: 'true',
    label: 'Yes',
    value: 'true'
  }, {
    key: 'false',
    label: 'No',
    value: 'false'
  }],
  title: 'Have you ever received a blood transfusion?',
  validation: []
};
exports.receivedBloodTransfusionOption = receivedBloodTransfusionOption;
var receivedBloodTransfusionReason = {
  key: 'reason',
  name: 'reason',
  type: 'text',
  label: 'Please provide details of the transfusion',
  description: "Answering YES will not necessarily exclude you from the register, so please give us all the detail you can, and we'll be in touch if we need more information.",
  ui: {
    classes: 'large'
  },
  validation: []
};
exports.receivedBloodTransfusionReason = receivedBloodTransfusionReason;
var receivedBloodTransfusionYear = {
  key: 'year',
  name: 'year',
  label: 'Year',
  type: 'select',
  items: (0, _range.yearRange)(0, -31),
  ui: {
    classes: 'span_5_of_12'
  },
  validation: []
};
exports.receivedBloodTransfusionYear = receivedBloodTransfusionYear;
var receivedBloodTransfusionCountry = {
  key: 'country',
  type: 'select',
  label: 'Country',
  items: _countryList["default"],
  ui: {
    classes: ''
  },
  validation: []
};
exports.receivedBloodTransfusionCountry = receivedBloodTransfusionCountry;

var ReceivedBloodTransfusionDefinition = _flowRuntime["default"].type("ReceivedBloodTransfusionDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(ComponentElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string("receivedBloodTransfusion")))));

exports.ReceivedBloodTransfusionDefinition = ReceivedBloodTransfusionDefinition;
var receivedBloodTransfusionConfig = {
  type: 'receivedBloodTransfusion',
  fields: [receivedBloodTransfusionYear, receivedBloodTransfusionReason, receivedBloodTransfusionOption, receivedBloodTransfusionCountry],
  validation: [{
    receivedBloodTransfusionRequired: true
  }]
};
exports.receivedBloodTransfusionConfig = receivedBloodTransfusionConfig;
var receivedBloodTransfusion = {
  key: 'receivedBloodTransfusion',
  type: 'receivedBloodTransfusion'
};
exports.receivedBloodTransfusion = receivedBloodTransfusion;